import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {getValidatedLimit} from "../../components/Utility";
import {BankFormSchema} from "../../schema/bankSchema";
import {getBankSettingFormData} from "../../models/bankModel";
import {fetchBankById, CreateBank} from "../../store/bank-setting-slice";

const BankEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.bankSetting);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        createStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.bankSetting);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchBankById({...userRole, id: params.bankId}));
    }, [dispatch, params.bankId, userRole]);

    const bank = items.find(item => item.id === params.bankId);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [createStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId,
            accountNumber: Number(data.accountNumber),
        };

        dispatch(CreateBank({...userRole, data: updatedData}))
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const schema = BankFormSchema();
    const initialData = getBankSettingFormData(bank);

    return (
        <>
            <SubHeader title="Update Bank">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={createStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default BankEdit;
